import { projectFoldersApi } from "./projectCoreAxios";
import { ApiFolder } from "../shared/interfaces";
import type {
    DeleteFolderResponse,
    FolderCreateInput,
    FolderListScope,
    FolderUpdateInput,
    FoldersListResponse,
} from "./projectCore";
export type {
    DeleteFolderResponse,
    FolderCreateInput,
    FolderListScope,
    FolderUpdateInput,
    FoldersListResponse,
} from "./projectCore";

export const FoldersApi = {
    /** Additional docs' folders without `scope` (the request the shipped iOS client makes). */
    list: async (scope?: FolderListScope): Promise<FoldersListResponse> =>
        projectFoldersApi.list(undefined, scope),
    create: async (input: FolderCreateInput): Promise<ApiFolder> => projectFoldersApi.create(input),
    update: async (id: string, input: FolderUpdateInput): Promise<ApiFolder> =>
        projectFoldersApi.update(id, input),
    remove: async (id: string): Promise<DeleteFolderResponse> => projectFoldersApi.remove(id),
};
